<template>
    <!-- 资源组详情和主机管理的详情中的脚本组件 -->
    <div class="module script-compontent-list">
        <div class="module-container">
            <rcTable ref="resScriptTable"
                     v-if="isChange"
                     :tableAttr="tableAttr">
                <div class="title-text"
                     slot="tootipL">
                    <i class="icon-network-2-o"></i> {{$t('执行记录')}}</div>
            </rcTable>
        </div>
        <!-- <logModal ref="logModal"></logModal> -->
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'scriptcompontent',
    props: ['quote', 'isLocak', 'baseInfo'], // 该参数用于区分此组件是被哪里调用的,
    components: {
        rcTable
    },
    data () {
        return {
            isChange: false,
            urlApi: '',
            tableAttr: {
                source: {
                    type: 'staticData',
                    // 根据angular版本思路，该列表需要调用四个接口进行数据拼装，因此只能写成静态数据
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                pageData: {
                    show: true, // 是否展示分页
                    showElevator: true, // 显示电梯，可以快速切换到某一页
                    pageWays: 'client' // 默认客户端分页
                },
                searchShow: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$i18n.t('脚本名称'),
                        key: 'name',
                        className: 'ellipsis',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true
                        // render: (h, params) => {
                        //     return h('a', { attrs: { title: params.row.name }, on: { click: () => this.detailFun(params.row.scriptId) } }, params.row.name)
                        // }
                    }, {
                        title: this.$i18n.t('脚本描述'),
                        key: 'description',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.description } }, params.row.description)
                        }
                    }, {
                        title: this.$i18n.t('配置参数'),
                        key: 'paramConfigs',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            let data = ''
                            if (params.row.paramConfigs) {
                                data = params.row.paramConfigs.map(item => item.name + '=' + item.defaultValue + ' ')
                            } else {
                                data = null
                            }
                            const dataTips = data.join(' ')
                            return h('Tooltip', {
                                props: {
                                    transfer: true,
                                    placement: 'right',
                                    theme: 'light',
                                    content: dataTips
                                }
                            }, data)
                        }
                    }, {
                        title: this.$i18n.t('脚本分类'),
                        key: 'scriptCategory',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            let data = ''
                            switch (params.row.scriptCategory) {
                                case 'boot':
                                    data = this.$i18n.t('启动脚本')
                                    break
                                case 'decommission':
                                    data = this.$i18n.t('执行脚本')
                                    break
                                case 'operational':
                                    data = this.$i18n.t('操作脚本')
                                    break
                                case 'other':
                                    data = this.$i18n.t('其他脚本')
                                    break
                                case 'stop':
                                    data = this.$i18n.t('停止脚本')
                                    break
                            }
                            return h('span', data)
                        }
                    }, {
                        title: this.$i18n.t('时间'),
                        key: 'time',
                        className: 'ellipsis',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.time } }, params.row.time)
                        }
                    }
                ]
            }
        }
    },
    created () {
        // 不同的地方调用不同接口
        switch (this.quote) {
            case 'source':
                this.urlApi = API.GET_RESGROUP_SCRIPTS
                break
            case 'host':
                this.urlApi = API.GET_HOST_SCRIPT
                break
        }
        this.getReSGroupFun()
    },
    methods: {
        // 脚本获取所有数据,因为需要从5个接口来获取因此采用此方案（待改进）
        async getReSGroupFun () {
            this.tableAttr.source.tableData.totalRows = 0
            this.tableAttr.source.tableData.dataList = []
            const otherSc = await this.getAiax(this.urlApi, 'other')
            const decommissionSc = await this.getAiax(this.urlApi, 'decommission')
            const operationalSc = await this.getAiax(this.urlApi, 'operational')
            const bootSc = await this.getAiax(this.urlApi, 'boot')
            const stopSc = await this.getAiax(this.urlApi, 'stop')
            const newArr = [].concat(otherSc, decommissionSc, operationalSc, bootSc, stopSc)
            this.tableAttr.source.tableData.totalRows = newArr.length
            this.tableAttr.source.tableData.dataList = newArr
            this.isChange = true
        },
        getAiax (url, code) {
            return this.axios.get(this.urlFormat(url, true, [this.$route.params.id, code]))
        }
    }
}
</script>
<style lang="less">
.script-compontent-list {
    .rcTable-head {
        margin-bottom: 0 !important;
        padding: 9px 15px;
        border: 1px solid #e8eaec;
        border-bottom: 0;
        margin-top: 15px;
    }
    .disabledA {
        color: #ccc !important;
        cursor: not-allowed !important;
        pointer-events: none;
    }
}
</style>
<style lang="less" scoped>
.script-compontent-list {
    .title-text {
        display: block;
        font-size: 14px;

        color: #666;
    }
    .params-title {
        font-weight: bold;
        font-size: 14px;
        color: #333;
        padding: 15px 0px;
    }
}
</style>
